<template>
  <div class="restaurant-list-hz">
    <!-- Loading state -->
    <div
      v-if="isLoading"
      class="flex gap-4 overflow-x-auto pb-4 px-6 scrollbar-hide"
    >
      <div
        v-for="i in shimmerCount"
        :key="`shimmer-${i}`"
        class="flex-shrink-0 w-[80vw] max-w-sm"
      >
        <div class="w-full relative">
          <div
            class="relative w-full h-full top-0 left-0 rounded-3xl overflow-hidden"
          >
            <div class="relative p-[35%] border border-transparent">
              <div
                class="rounded-3xl bg-slate-100 overflow-hidden w-full h-full absolute top-0 left-0 flex items-center flex-col justify-center"
              >
                <div
                  class="absolute w-full h-full duration-300 shimmer-animation"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Restaurants list (horizontal scroll) -->
    <div
      v-else-if="displayedRestaurants && displayedRestaurants.length > 0"
      class="flex gap-4 overflow-x-auto pb-4 px-6 scrollbar-hide"
    >
      <div
        v-for="(restaurant, i) in displayedRestaurants"
        :key="restaurant.id || i"
        class="flex-shrink-0 w-[80vw] max-w-sm"
      >
        <RestaurantCard :item="restaurant" />
      </div>
    </div>

    <!-- Empty state -->
    <SectionEmptyState
      v-else
      :title="emptyTitle || 'Bientôt disponible'"
      :description="emptyDescription || 'De nouveaux restaurants arrivent bientôt !'"
      :icon-type="type"
      :show-refresh="!!refreshEvent"
      @refresh="refresh"
    />
  </div>
</template>

<script>
import { computed } from 'vue';
import RestaurantCard from './RestaurantCard.vue';

export default {
  name: 'RestaurantListHz',

  components: {
    RestaurantCard
  },

  props: {
    restaurants: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: null
    },
    limit: {
      type: Number,
      default: 0
    },
    shimmerCount: {
      type: Number,
      default: 5
    },
    type: {
      type: String,
      default: 'default'
    },
    emptyTitle: {
      type: String,
      default: ''
    },
    emptyDescription: {
      type: String,
      default: ''
    },
    refreshEvent: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      showPlaceholder: false
    };
  },

  computed: {
    placeholderImage() {
      return '/images/placeholders/restaurant-dishes.png';
    },

    // Use provided restaurants prop, or fall back to store
    restaurantList() {
      if (this.restaurants !== null) {
        return this.restaurants;
      }
      // Read from home store - use popular restaurants
      return this.$stores?.home?.popularRestaurants || [];
    },

    isLoading() {
      if (this.loading !== null) {
        return this.loading;
      }
      // Read from home store
      return this.$stores?.home?.state?.featured?.loading || false;
    },

    displayedRestaurants() {
      if (!this.limit || !this.restaurantList) {
        return this.restaurantList;
      }
      return this.restaurantList.slice(0, this.limit);
    }
  },

  mounted() {
    setTimeout(() => {
      this.showPlaceholder = true;
    }, 5000);
  },

  methods: {
    showRestaurantDetail(restaurant) {
      if (!restaurant || !restaurant.id) return;
      this.$bus.emit('restaurant.SHOW_RESTAURANT_DETAIL', {
        id: restaurant.id
      });
    },

    refresh() {
      if (this.refreshEvent) {
        this.$bus.emit(this.refreshEvent);
      }
    },

    handleImageLoad(event) {
      event.target.style.backgroundColor = 'white';
    },

    handleImageError(event) {
      event.target.style.display = 'none';
    }
  }
};
</script>